export const armonizacion = [
   {
      "id_trimestre":"TERCER TRIMESTRE 2026",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/1. INFORMACION CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/1. INFORMACION CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/1. INFORMACION CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/1. INFORMACION CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación Económica (Por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación por Objeto del Gasto (Capitulo y Concepto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores de Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educación Tecnológica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado – LDF Clasificación por objeto del Gasto (Capítulo y concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2026",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/1. INFORMACION CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/1. INFORMACION CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/1. INFORMACION CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/1. INFORMACION CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación Económica (Por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación por Objeto del Gasto (Capitulo y Concepto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores de Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educación Tecnológica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado – LDF Clasificación por objeto del Gasto (Capítulo y concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2026",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/1. INFORMACION CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/1. INFORMACION CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/1. INFORMACION CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/1. INFORMACION CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/1. INFORMACION CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación Económica (Por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación por Objeto del Gasto (Capitulo y Concepto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores de Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educación Tecnológica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado – LDF Clasificación por objeto del Gasto (Capítulo y concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2026/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"CUENTA PÚBLICA 2025",
      "titulos_array":[
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"CUENTA PÚBLICA 2025",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUENTA PUBLICA 2025/Cuenta publica 2025.zip"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"ACUSE CUENTA PÚBLICA 2025",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUENTA PUBLICA 2025/Acuse Cuenta Publica 2025.pdf"
               }
            ]
         }         
      ]   
   },     
   {
      "id_trimestre":"CUARTO TRIMESTRE 2025",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Económica (Por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación por Objeto del Gasto (Capitulo y Concepto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores de Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educación Tecnológica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores de Postura Fiscal (Flujo de fondo)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Flujos de fondo 2025.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado – LDF Clasificación por objeto del Gasto (Capítulo y concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
  {
      "id_trimestre":"TERCER TRIMESTRE 2025",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Económica (Por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación por Objeto del Gasto (Capitulo y Concepto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores de Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado – LDF Clasificación por objeto del Gasto (Capítulo y concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2025",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Económica (Por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación por Objeto del Gasto (Capitulo y Concepto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores de Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado – LDF Clasificación por objeto del Gasto (Capítulo y concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2025",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Económica (Por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación por Objeto del Gasto (Capitulo y Concepto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores de Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado – LDF Clasificación por objeto del Gasto (Capítulo y concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2025/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"CUENTA PÚBLICA 2024",
      "titulos_array":[
         {
            "titulo_item_nombre":"",
            "archivos_array":[
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"CUENTA PÚBLICA 2024",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUENTA PUBLICA 2024/Cuenta publica 2024.zip"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"ACUSE CUENTA PÚBLICA 2024",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUENTA PUBLICA 2024/Acuse Cuenta Publica 2024.pdf"
               }
            ]
         }         
      ]   
   },            
   {
      "id_trimestre":"CUARTO TRIMESTRE 2024",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"TERCER TRIMESTRE 2024",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2024",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2024",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para la difusión a la ciudadanía de la Ley de Ingresos y del Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         },
         {
            "titulo_item_nombre":"Manual de Contabilidad Gubernamental SSH EJERCICIO 2024",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Manual de Contabilidad Gubernamental SSH EJERCICIO 2024",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2024/Manual de Contabilidad Gubernamental SSH.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"CUENTA PÚBLICA 2023",
            "archivos_array":[
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"CUENTA PÚBLICA 2023",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/Cuenta publica 2023.zip"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"CUARTO TRIMESTRE 2023",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado analítico del activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado analítico de la deuda y otros pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de cambios en la situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de flujo de efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de situación financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de variación en la hacienda pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Informe de pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Notas de los estados financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Indicadores y Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"TERCER TRIMESTRE 2023",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado Analitico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado Analitico de la Deuda y Otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Cambios en la Situacion Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Situacion Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Variaciones en la Hacienda Publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Informe sobre Pasivos Contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificación Económica (por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Con).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Gasto por Categoria Programatica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversion.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Informe Aalítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2023",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado Analitico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado Analitico de la Deuda y Otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Cambios en la Situacion Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Situacion Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Variaciones en la Hacienda Publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Informe sobre Pasivos Contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Económica (por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Con).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Gasto por Categoria Programatica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversion.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio de Egresos Detallado Clasificación por Objeto del Gasto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situación Financiera Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de la Deuda Pública y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Informe Aalítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2023",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado Analítico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado Analítico de la Deuda y Otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Cambios en la Situacion Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Estado de Variacion en la Hacienda Publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Informe sobre pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Económica (por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Con).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Gasto por Categoria Programatica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/3. INFORMACION PROGRAMATICA/Programas y proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Formato del Ejercicio del Destino y Gasto Federalizado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Formato del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la informacion relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestal - LDF.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF (Capitulo y Concepto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF (Capitulo y Concepto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de Situacion Financiera Detallado LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado LDF.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe Analitico de la Deuda Publica y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"CUENTA PÚBLICA 2022",
            "archivos_array":[
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Cuenta pública 2022",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2023/CUENTA PUBLICA 2022.zip"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"CUARTO TRIMESTRE 2022",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado Analítico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado Analítico de la Deuda y Otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Cambios en la Situacion Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Variacion en la Hacienda Publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Informe sobre pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por Clasificación Económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Económica (por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos por Clasificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Consolidado por el Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Con).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, Capitulo y Partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el Ejercicio de los Ingresos por Rubro, Tipo, Clase y Concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por Categoría Programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Gasto por Categoria Programatica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y Resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y Proyectos de Inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Programas y proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la informacion relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"TERCER TRIMESTRE 2022",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado Analítico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado Analítico de la Deuda y Otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Cambios en la Situacion Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Variacion en la Hacienda Publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Informe sobre pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Económica (por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Con).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el ejercicio de los ingresos por rubro, tipo, clase y concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Programas y proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información de programas de recursos federales por orden de Gob.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la informacion relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestal - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio Egresos Detallado por Ob del Gto - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situacion Financiera Detallado LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de la Deuda Publica y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2022",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado Analítico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado Analítico de la Deuda y Otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Cambios en la Situacion Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Variacion en la Hacienda Publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Informe sobre pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Económica (por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Con).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el ejercicio de los ingresos por rubro, tipo, clase y concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Programas y proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información de programas de recursos federales por orden de Gob.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la informacion relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestal - LDF - Enero - Junio.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF - Enero - Junio.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Edo.Analítico del Ejercicio del Ppto. de Egresos Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Edo Analítico del Ejercicio del Pto de Egresos Detallado - LDF Clasificación de Servicios Personales por Categoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Edo.Analítico del Ejercicio del Ppto. de Egresos Detallado - LDF Clasificación Administrativa - Enero - Junio 2022.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Edo.Analítico del Ejercicio del Pto de Egresos Detallado - LDF Clasificación por Objeto del Gto (Capítulo y Concepto).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situacion Financiera Detallado LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF - Enero - Junio.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de la Deuda Publica y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF - Enero - Junio.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF - Enero - Junio.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2022",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado Analítico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado Analítico de la Deuda y Otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Cambios en la Situacion Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Estado de Variacion en la Hacienda Publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Informe sobre pasivos contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Económica (por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Funcional (Finalidad y Función).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación por Objeto del Gasto (Capítulo y Con).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analítico del Ejercicio del Presupuesto de Egresos Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el ejercicio de los ingresos por rubro, tipo, clase y concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/3. INFORMACION PROGRAMATICA/Programas y proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información de programas de recursos federales por orden de Gob.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la informacion relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestal - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejer del Pto de Eg Detallado - LDF Clasificación Funcional (Finalidad y Función).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejer del Pto de Eg Detallado - LDF CSPCategoría.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejer del Pto de Eg Detallado - LDF Clasificación Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejer del Pto de Eg Detallado - LDF Clasificación por Ob del Gto (Cap y Con).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situacion Financiera Detallado LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situación Financiera Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de la Deuda Publica y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de la Deuda Pública y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/5. LEY DE DISCIPLINA FINANCIERA/Informe Analítico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         },
         {
            "titulo_item_nombre":"CUENTA PÚBLICA 2021",
            "archivos_array":[
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Cuenta pública 2021",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2022/CUENTA PUBLICA 2021.zip"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"CUARTO TRIMESTRE 2021",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado Analitico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado Analitico de la Deuda y otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Cambios en Situacion Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Situacion Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Variaciones en la Hacienda Publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Informe sobre Pasivos Contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificacion Economica (por Tipo de Gasto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificacion Funcional (Finalidad y Funcion).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificacion por Objeto del Gasto (Capitulo y Concepto).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos Clasificacion Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado Analitico del Ejercicio del Presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el ejercicio de los ingresos por rubro, tipo, clase y concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Gasto por Categoria Programatica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversion.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Difusion a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Informacion Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Informacion Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educacion Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de Gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de informacion del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la informacion relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la informacion relativa a las aportaciones federales en materia de salud.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situacion Financiera Detallado LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situacion Financiera Detallado LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de la Deuda Publica y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Informe Analitico de la Deuda Publica y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"TERCER TRIMESTRE 2021",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado Analitico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado Analitico de la Deuda y otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Cambios en Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Variaciones en la Hacienda Publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Informe sobre Pasivos Contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Clasificación Económica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Clasificación Funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Objeto del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Fuente de Financiamiento, capitulo y partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el ejercicio de los ingresos por rubro, tipo, clase y concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro, Tipo, Clase y Concepto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Programas y proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de programas de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situacion Financiera Detallado LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situacion Financiera Detallado LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de la Deuda Publica y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Informe Analitico de la Deuda Publica y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2021",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado Analitico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado Analitico de la Deuda y otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Cambios en Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Variaciones en la Hacienda Publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Informe sobre Pasivos Contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Clasificación Económica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Clasificación Funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Objeto del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto e Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Endeudamiento Neto e Interes de la Deuda.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el ejercicio de los ingresos por rubro, tipo, clase y concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro y Fuente de Financiamiento.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Programas y proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de programas de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situacion Financiera Detallado LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situacion Financiera Detallado LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de la Deuda Publica y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Informe Analitico de la Deuda Publica y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2021",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado Analitico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado Analitico de la Deuda y otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Cambios en Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Estado de Variaciones en la Hacienda Publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Informe sobre Pasivos Contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Clasificación Económica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Clasificación Funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por capítulo del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Capítulo del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Objeto del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por fuente de financiamiento capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Fuente de Financiamiento, capitulo y partidas.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de Egresos por Clasificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analitico de Ingresos por Rubro y Fuente de Financiamiento",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro y Fuente de Financiamiento.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el ejercicio de los ingresos por rubro, tipo, clase y concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro y Fuente de Financiamiento.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Gasto por Categoría Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/3. INFORMACION PROGRAMATICA/Programas y proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Calendario Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de programas de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma sobre aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura del Ejercicio del Gasto Federalizado y Reintegros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Formato 7 a) Proyecciones de Ingreso",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/Proyecciones Ingresos  2021.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Formato 7 b) Proyecciones de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/Proyecciones Egresos 2021.xlsx"
               }
            ]
         },
         {
            "titulo_item_nombre":"CUENTA PÚBLICA 2020",
            "archivos_array":[
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Cuenta pública 2020",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/CUENTA PÚBLICA 2020.zip"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situacion Financiera Detallado LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situacion Financiera Detallado LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de la Deuda Publica y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Informe Analitico de la Deuda Publica y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2021/5. LEY DE DISCIPLINA FINANCIERA/Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"CUARTO TRIMESTRE 2020",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado Analitico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado Analitico de la Deuda y otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado de Cambios en la Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado de Flujo de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado de Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado de Variación en la Hacienda Pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/1. INFORMACION  CONTABLE/Informa sobre Pasivos Contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/1. INFORMACION  CONTABLE/Notas a los Etados Financieros.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Calsificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Clasificación Económica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Calsificación Funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por capítulo del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Capítulo del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Objeto del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por fuente de financiamiento capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Fuente de financiamiento capitulo y partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el ejercicio de los ingresos por rubro, tipo, clase y concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro y por Fuente de Financiamiento.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/Gasto por Categoria Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/Programas y proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"LEY DE DISCIPLINA FINANCIERA",
            "archivos_array":[
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Balance Presupuestario - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/5. LEY DE DISCIPLINA FINANCIERA/Balance Presupuestario - LDF.xlsx"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico de Ingresos Detallado - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico de Ingresos Detallado - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egr. Det LDF Clasificacion Funcional (Finalidad y Funcion).xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egr. Det. - LDF Clasificación de Servicios Personales por Categoria.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/5. LEY DE DISCIPLINA FINANCIERA/Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado - LDF Clasificacion Administrativa.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/5. LEY DE DISCIPLINA FINANCIERA/Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado por Objeto del Gasto - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Estado de Situacion Financiera Detallado LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/5. LEY DE DISCIPLINA FINANCIERA/Estado de Situacion Financiera Detallado LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de la Deuda Publica y Otros Pasivos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/5. LEY DE DISCIPLINA FINANCIERA/Informe Analitico de la Deuda Publica y Otros Pasivos - LDF.xls"
               },
               {
                  "extencion":"archivo-xls",
                  "file_item_nombre":"Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF",
                  "file_item_url":"../../contenido/transparencia/armonizacion/CUARTO TRIMESTRE 2020/5. LEY DE DISCIPLINA FINANCIERA/Informe Analitico de Obligaciones Diferentes de Financiamientos - LDF.xls"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"TERCER TRIMESTRE 2020",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado Analitico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado Analitico de la Deuda y otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado de Cambios en la Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado de Flujo de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado de Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/1. INFORMACION  CONTABLE/Estado de Variación en la Hacienda Pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/1. INFORMACION  CONTABLE/Informa Sobre Pasivos Contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/1. INFORMACION  CONTABLE/Endeudamiento Neto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/1. INFORMACION  CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/1. INFORMACION  CONTABLE/Notas a los Estados Financieros.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Calsificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Clasificación Económica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Calsificación Funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por capítulo del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Capítulo del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Objeto del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por fuente de financiamiento capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado del ejercicio del presupuesto de egresos por Fuente de financiamiento capitulo y partida.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el ejercicio de los ingresos por rubro, tipo, clase y concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro y por Fuente de Financiamiento.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/Gasto por Categoria Programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Calendario Presupuesto Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Formato del Ejercicio del Destino y Gasto Federalizado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Formato del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de programas de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de informacion de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Norma de Fondo de Aportaciones para la Educación Tecnológica y de Adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma sobre aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/TERCER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2020",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO DE ACTIVIDADES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO ANALITICO DEL ACTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO ANALITICO DE LA DEUDA Y OTROS PASIVOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO DE CAMBIOS EN LA SITUACIÓN FINANCIERA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO DE FLUJO DE EFECTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO DE SITIACIÓN FINANCIERA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO DE VARIACIÓN EN LA HACIENDA PÚBLICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/1. INFORMACION  CONTABLE/INFORME SOBRE PASIVOS CONTINGENTES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/1. INFORMACION  CONTABLE/ENDEUDAMIENTO NETO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/1. INFORMACION  CONTABLE/INTERESES DE LA DEUDA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/1. INFORMACION  CONTABLE/NOTAS A LOS EDOS FINANCIEROS.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DEL PRESUPUESTO DE EGRESOS POR CLAS ADMVA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DEL PRESUPUESTO DE EGRESOS POR CLAS ECONOMICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DEL PRESUPUESTO DE EGRESOS POR CLAS FUNCIONAL.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por capítulo del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DEL PRESUPUESTO DE EGRESOS POR CAPITULO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DEL PRESUPUESTO DE EGRESOS POR OBJETO DEL GASTO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por fuente de financiamiento capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DEL PRESUPUESTO DE EGRESOS POR FF, CAP Y PARTIDA.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el ejercicio de los ingresos por rubro, tipo, clase y concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/ESTADO ANALITICO DEL INGRESO.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/GASTO POR CATEGORIA PROGRAMATICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/INDICADORES DE RESULTADOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/PROGRAMAS Y PROYECTOS DE INVERSIÓN.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Calendario Presupuesto Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Formato del Ejercicio del Destino y Gasto Federalizado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/7 Formato del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/8 Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de programas de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/9 Norma para establecer la estructura de informacion de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma sobre aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/13 Norma sobre aportaciones federales en materia de salud.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondos de Ayuda Federal para la Seguridad Pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/14 Normas y modelo de estructura de información relativa alos Fondos de Ayuda Federal para la Seguridad Pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/15 Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/SEGUNDO TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/16 Lineamientos de información pública financiera para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2020",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO DE ACTIVIDADES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO ANALITICO DEL ACTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO ANALITICO DE LA DEUDA Y OTROS PASIVOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO DE CAMBIOS EN LA SITUACIÓN FINANCIERA_rotated.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO DE FLUJO DE EFECTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO DE SITUACIÓN FINANCIERA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/1. INFORMACION  CONTABLE/ESTADO DE VARIACIÓN EN LA HDA PÚBLICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/1. INFORMACION  CONTABLE/INFORME SOBRE PASIVOS CONTINGENTES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/1. INFORMACION  CONTABLE/ENDEUDAMIENTO NETO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/1. INFORMACION  CONTABLE/INTERESES DE LA DEUDA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/1. INFORMACION  CONTABLE/NOTAS A LOS ESTADOS FINANCIEROS.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/EDO ANALITICO DE EGRESOS POR CLASIFICACIÓN ADMINISTRATIVA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/EDO ANALITICO DE EGRESOS POR CLASIFICACIÓN ECONOMICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/EDO ANALITICO DE EGRESOS POR CLAS FUNCIONAL.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por capítulo del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/EDO ANALITICO DE EGRESOS POR CAPITULO DEL GASTO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/EDO ANALITICO DE EGRESOS POR OBJETO DEL GASTO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por fuente de financiamiento capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/EDO ANALITICO DE EGRESOS POR FF CAPITULO Y PARTIDA.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado sobre el ejercicio de los ingresos por rubro, tipo, clase y concepto ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/2. INFORMACION PRESUPUESTARIA/EDO ANALITICO DE EGRESOS POR FF CAPITULO Y PARTIDA.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/GASTO POR CATEGORIA PROGRAMATICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/INDICADORES DE RESULTADOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/3. INFORMACION PROGRAMATICA/PROGRAMAS Y PROYECTOS DE INVERSIÓN.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Calendario Presupuesto Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Información Adicional Proyecto Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Formato del Ejercicio del Destino y Gasto Federalizado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/7 Formato del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/8 Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de programas de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/9 Norma de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma sobre aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/13 Norma sobre aportaciones federales en materia de salud.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de Fondos de Ayuda Federal para la Seguridad Pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/14 Norma de Fondos de Ayuda Federal para la Seguridad Pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/15 Norma de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/4. INFORMACION COMPLEMENTARIA/16 Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"OTRA INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Cuenta pública 2019",
                  "file_item_url":"../../contenido/transparencia/armonizacion/PRIMER TRIMESTRE 2020/CUENTA PUBLICA 1er trim 2020.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"CUARTO TRIMESTRE 2019",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE ACTIVIDADES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/1. INFORMACION CONTABLE/ESTADO ANALÍTICO DEL ACTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/1. INFORMACION CONTABLE/ESTADO ANALÍTICO DE LA DEUDA Y OTROS PASIVOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE CAMBIOS EN LA SITUACIÓN FIANCIERA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE FLUJO DE EFECTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE SITUACIÓN FINANCIERA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/1. INFORMACION CONTABLE/ESTAD DE VARIACIÓN EN LA HACIENDA PÚBLICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/1. INFORMACION CONTABLE/INFORME DE PASIVOS CONTINGENTES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/1. INFORMACION CONTABLE/ENDEUDAMIENTO NETO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/1. INFORMACION CONTABLE/INTERESES DE LA DEUDA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/1. INFORMACION CONTABLE/NOTAS A LOS ESTADOS FINANCIEROS.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO ANALÍTICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS CONSOLIDADO POR CLASIFICACIÓN ADMINISTRATIVA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por clasificación económica (por tipo de gasto)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO ANALÍTICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS CONSOLIDADO POR CLASIFICACIÓN ECONÓMICA (POR TIPO DE GASTO).pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO ANALÍTICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS CONSOLIDADO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por capítulo del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS CONSOLIDADO POR CAPÍTULO DEL GASTO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por el objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS CONSOLIDADO POR EL OBJETO DEL GASTO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por fuente de financiamiento capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS POR FUENTE DE FINANCIAMIENTO CAPITULO Y PARTIDA.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ingreso",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/2. INFORMACION PRESUPUESTARIA/INGRESO/ESTADO ANALÍTICO DEL INGRESO.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/3. INFORMACION PROGRAMATICA/GASTO POR CATEGORÍA PROGRÁMATICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/3. INFORMACION PROGRAMATICA/INDICADORES DE RESULTADOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/3. INFORMACION PROGRAMATICA/PROGRAMAS Y PROYECTOS DE INVERSIÓN.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"1. Información Adicional a la Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/1. Información Adicional a la Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"2.  Información Adicional del Proyecto del Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/2.  Información Adicional del Proyecto del Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"3. Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/3. Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"4 Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/4 Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"5. Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/5. Calendario Presupuesto Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"6 Montos Pagados por Ayudas y Subsidios",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/6 Montos Pagados por Ayudas y Subsidios.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"7 Formato del Ejercicio del Destino y Gasto Federalizado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/7 Formato del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"8 Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/8 Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"9 Norma de programas de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/9 Norma de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"10 Relación de Cuentas bancarias consolidado 2019",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/10 Relación de Cuentas bancarias consolidado 2019.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"14 Normas y modelo de estructura de información relativa alos Fondos de Ayuda Federal para la Seguridad Pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/14 Normas y modelo de estructura de información relativa alos Fondos de Ayuda Federal para la Seguridad Pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"15 Norma para establecer la estructura de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/15 Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"16 Lineamientos para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2019/4. INFORMACION COMPLEMENTARIA/16 Lineamientos para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"TERCER TRIMESTRE 2019",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Dictaminación de Estados Finacieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/DICTAMEN 2018.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE ACTIVIDADES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/1. INFORMACION CONTABLE/ESTADO ANALÍTICO DEL ACTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/1. INFORMACION CONTABLE/ESTADO ANALÍTICO DE LA DEUDA Y OTROS PASIVOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE CAMBIOS EN LA SITUACIÓN FINANCIERA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DEL FLUJO DE EFECTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE SITUACIÓN FINANCIERA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE VARIACIÓN EN LA HACIENDA PÚBLICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/1. INFORMACION CONTABLE/INFORME DE PASIVOS CONTINGENTES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/1. INFORMACION CONTABLE/ENDEUDAMIENTO NETO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/1. INFORMACION CONTABLE/INTERESES DE LA DEUDA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/1. INFORMACION CONTABLE/NOTAS A LOS ESTADOS FINANCIEROS.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación económica",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO ANALÍTICO DEL EJERCICIO DE PRESUPUESTO DE EGRESOS POR CLASIFICACIÓN ECONOMICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado por objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO ANALÍTICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS CONSOLIDADO POR OBJETO DEL GASTO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos por clasificación administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO ANALÍTICO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS POR CLASIFICACIÓN ADMINISTRATIVA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del presupuesto de egresos por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO ANALÍTICO DEL PRESUPUESTO DE EGRESOS POR CLASIFICACIÓN FUNCIONAL.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de egresos por capítulo del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS  POR CAPITULO DEL GASTO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de egresos por fuente de financiamiento, capítulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/ESTADO DEL EJERCICIO DEL PRESUPUESTO DE EGRESOS POR FF, CAPITULO Y PARTIDA.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de ingresos por rubro de ingresos y por fuente de financioamiento",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/2. INFORMACION PRESUPUESTARIA/INGRESO/ESTADO ANALÍTICO DE INGRESOS POR RUBRO Y FF.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/3. INFORMACION PROGRAMATICA/GASTO POR CATEGORÍA PROGRAMÁTICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores y resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/3. INFORMACION PROGRAMATICA/INDICADORES DE RESULTADOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/3. INFORMACION PROGRAMATICA/PROGRAMAS Y PROYECTOS DE INVERSIÓN.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"1. Información Adicional a la Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/1. Información Adicional a la Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"2.  Información Adicional del Proyecto del Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/2.  Información Adicional del Proyecto del Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"3. Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/3. Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"4 Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/4 Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"5. Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/5. Calendario Presupuesto Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"6 Montos Pagados por Ayudas y Subsidios",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/6 Montos Pagados por Ayudas y Subsidios.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"7 Formato del Ejercicio del Destino y Gasto Federalizado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/7 Formato del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"8 Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/8 Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"9 Norma de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/9 Norma de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"10 Relación de Cuentas bancarias",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/10 Relación de Cuentas bancarias.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"13 Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/13 Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"14 Norma de  Fondos de Ayuda Federal para la Seguridad Pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/14 Norma de  Fondos de Ayuda Federal para la Seguridad Pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"15 Norma para establecer la estructura de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/15 Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"16 Lineamientos  para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2019/4. INFORMACION COMPLEMENTARIA/16 Lineamientos  para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2019",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE ACTIVDADES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/1. INFORMACION CONTABLE/ESTADO ANALITICO DEL ACTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/1. INFORMACION CONTABLE/ESTADO ANALITICO DE LA DEUDA Y OTROS PASIVOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE CAMBIOS EN LA SITUACION FINANCIERA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE FLUJO DE EFECTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE SITUACION FINANCIERA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/1. INFORMACION CONTABLE/ESTADO DE VARIACION EN LA HDA PUBLICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/1. INFORMACION CONTABLE/INFORME DE PASIVOS CONTINGENTES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/1. INFORMACION CONTABLE/ENDEUDAMIENTO NETO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/1. INFORMACION CONTABLE/INTERESES DE LA DEUDA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/1. INFORMACION CONTABLE/NOTAS A LOS ESTADOS FINANCIEROS .pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de ingresos consolidado por capitulo del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/PTO DE EG POR CAPITULO DEL GASTO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado clasificación administrativa ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/PTO EG POR CLASIFICACION ADMINISTRATIVA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado clasificación economica (por tipo de gasto) ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/PTO DE EG POR CLASIFICACION ECONOMICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado clasificación funcional (finalidad y función) ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/PTO DE EG POR CLASIFICACION FUNCIONAL.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de egresos por fuente de financiamiento, capítulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/PTO DE EG POR F.F. CAPITULO Y PARTIDA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuestal de egresos consolidado clasificación por objeto del gasto (capitulo y concepto) ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/2. INFORMACION PRESUPUESTARIA/EGRESO/PRESUPUESTAL DE EG POR OBJETO DEL GASTO.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de ingresos por rubro de ingresos y por fuente de financioamiento",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/2. INFORMACION PRESUPUESTARIA/INGRESO/ESTADO ANALITICO DEL INGRESO POR RUBRO YFF.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/3. INFORMACION PROGRAMATICA/GASTOS POR CATEGORIA PROGRAMATICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Catálogo de indicadores",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/3. INFORMACION PROGRAMATICA/INDICADORES DE RESULTADOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/3. INFORMACION PROGRAMATICA/PROGRAMAS Y PROYECTOS DE INVERSIÓN.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"1. Información Adicional a la Iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/1. Información Adicional a la Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"2.  Información Adicional del Proyecto del Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/2.  Información Adicional del Proyecto del Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"3. Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/3. Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"4 Calendario Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/4 Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"5. Calendario Presupuesto Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/5. Calendario Presupuesto Egresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"6 Montos Pagados por Ayudas y Subsidios",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/6 Montos Pagados por Ayudas y Subsidios.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"7 Formato del Ejercicio del Destino y Gasto Federalizado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/7 Formato del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"8 Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/8 Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"9 Norma para establecer la estructura de informacion de programas de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/9 Norma para establecer la estructura de informacion de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"10 Relación de Cuentas bancarias consolidado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/10 Relación de Cuentas bancarias consolidado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"14 Normas y modelo de estructura de información relativa alos Fondos de Ayuda Federal para la Seguridad Pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/14 Normas y modelo de estructura de información relativa alos Fondos de Ayuda Federal para la Seguridad Pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"15 Norma para establecer la estructura de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/15 Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"16 Lineamientos de información pública financiera para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/4. INFORMACION COMPLEMENTARIA/16 Lineamientos de información pública financiera para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"REGISTRO PATRIMONIAL",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Bienes inmuebles",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/BIENES INMUEBLES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Bienes muebles",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2019/BIENES MUEBLES 1.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2019",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/1. INF CONTABLE/edo_actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/1. INF CONTABLE/edo_analitico_activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/1. INF CONTABLE/edo_analitico_deuda_otros_pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/1. INF CONTABLE/edo_cambios_situacion_financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/1. INF CONTABLE/edo_flujo_efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/1. INF CONTABLE/edo_situacion_financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/1. INF CONTABLE/edo_variacion_hacienda_publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/1. INF CONTABLE/endeudamiento_neto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/1. INF CONTABLE/intereses_deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas de los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/1. INF CONTABLE/notas_edos_financieros.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "texto":"EGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de ingresos consolidado por capitulo del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/2. INF PRESUPUESTARIA/EGRESO/edo_analitico_egreso_capitulo_gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado clasificación administrativa ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/2. INF PRESUPUESTARIA/EGRESO/edo_analitico_egreso_clasificacion_admtva.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado clasificación economica (por tipo de gasto) ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/2. INF PRESUPUESTARIA/EGRESO/edo_analitico_egreso_clasificacion_economica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos consolidado clasificación funcional (finalidad y función) ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/2. INF PRESUPUESTARIA/EGRESO/edo_analitico_egreso_clasificacion_funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del ejercicio del presupuesto de egresos por fuente de financiamiento, capítulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/2. INF PRESUPUESTARIA/EGRESO/edo_analitico_egreso_fuente_finan_cap_partida.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuestal de egresos consolidado clasificación por objeto del gasto (capitulo y concepto) ",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/2. INF PRESUPUESTARIA/EGRESO/edo_analitico_egreso_objeto_gasto.pdf"
               },
               {
                  "texto":"INGRESO",
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de ingresos por rubro de ingresos y por fuente de financioamiento",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/2. INF PRESUPUESTARIA/INGRESO/edo_analitico_ingresos.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/3. INF PROGRAMATICA/gasto_categoria_programatica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Catálogo de indicadores",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/3. INF PROGRAMATICA/indicador_resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/3. INF PROGRAMATICA/programas_proyectos_inversion.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Lineamientos de información pública financiera para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/4. INFORMACIÓN COMPLEMENTARIA/lineamientos_fondo_aportaciones_infraestructura_social.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Formato de programas con recursos concurrente por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/4. INFORMACIÓN COMPLEMENTARIA/norma_ programas_federales_orden_gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de la información que las entidades federativas deberán presentar respecto al Fondo de Aportaciones para la Educación Tecnológica y de Adultos y los Formatos de presentación",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/4. INFORMACIÓN COMPLEMENTARIA/norma_fondo_aportaciones_educacion_tecnologica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Normas y modelo de estructura de información relativa a los Fondos de Ayuda Federal para la Seguridad Pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/4. INFORMACIÓN COMPLEMENTARIA/norma_fondos_ayuda_fed_seg_publica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para establecer la estructura de información del formato de aplicación de recursos del Fondo de Aportaciones para el Fortalecimiento de los Municipios y de las Demarcaciones Territoriales del Distrito Federal (FORTAMUN)",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/4. INFORMACIÓN COMPLEMENTARIA/norma_formato_fondo_FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"NORMA PARA ESTABLECER LA ESTRUCTURA DE INFORMACION DE OBLIGACIONES PAGADAS O GARANTIZADAS CON FONDOS FEDERALES",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/4. INFORMACIÓN COMPLEMENTARIA/norma_obligaciones_pagadas_garantizadas_fondos_federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Saldos bancarios",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/4. INFORMACIÓN COMPLEMENTARIA/relación_cuentas_bancarias_productivas_especificas.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para presentar la información adicional a la iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/Información Adicional Iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Norma para presentar la información adicional del Proyecto del Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/Información Adicional Proyecto Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Difusión a la Ciudadanía de la Ley de Ingresos y del Presupuesto Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/Difusión a ciudadania de la Ley de Ingresos y Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario de Ingresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/Calendario Ingresos Base Mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Calendario del Presupuesto de Egresos Base Mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/Calendario Presupuesto Egresos Base Mensual.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"REGISTRO PATRIMONIAL",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Bienes inmuebles",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/BIENES INMUEBLES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Bienes muebles",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Primer Trimestre 2019/BIENES MUEBLES 1.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"CUARTO TRIMESTRE 2018",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/1. INFORMACION CONTABLE/edo_actividades4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/1. INFORMACION CONTABLE/edo_situacion_financiera4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/1. INFORMACION CONTABLE/edo_variacion_hacienda_publica4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo efectivo",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/1. INFORMACION CONTABLE/edo_flujos_efectivo_4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/1. INFORMACION CONTABLE/edo_cambios_situacion_financiera4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analitíco del activo",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/1. INFORMACION CONTABLE/edo_analitico_activo4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analitíco de la deuda y otros pasivos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/1. INFORMACION CONTABLE/edo_analitico_deuda_otros_pasivos4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas a los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/1. INFORMACION CONTABLE/notas4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/1. INFORMACION CONTABLE/endeudamiento_neto4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/1. INFORMACION CONTABLE/intereses_deuda4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/1. INFORMACION CONTABLE/pasivos_contingentes4.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de ingresos por rubro y por fuente de financiamiento",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/2. INFORMACION PRESUPUESTARIA/edo_analitico_ingresos_rubro_financiamiento4.pdf"
               },
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/2. INFORMACION PRESUPUESTARIA/estado analitico del ejercicio del presupuesto de egresos.zip"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoria programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/3. INFORMACION PROGRAMATICA/gasto_categoria_programatica4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores de resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/3. INFORMACION PROGRAMATICA/indicadores_resultados4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/3. INFORMACION PROGRAMATICA/programas_proyectos_inversión4.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"1 Norma para presentar la información adicional a la iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/1 norma_informacion_adicional_iniciativa_ley_ingresos4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"2 norma para presentar la información adicional del Proyecto del Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/2 norma_información_adicional_proyecto_presupuesto_egresos4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"3 Difusión a la Ciudadania de la Ley de Ingresos y del Presupuesto Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/3 difusión_ciudadania_ley_ingresos_presupuesto_egresos4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"4 Norma para establecer la estructura del Calendario de Ingresos Base mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/4 norma_establecer_estructura_calendario_ingresos_base_mensual4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"5 Norma para establecer la estructura del Calendario del Presupuesto de Egresos base mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/5 norma_establecer_estructura_calendario_presupuesto_egresos_base_mensual4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"6 Montos Pagados por Ayudas y Subsidios",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/6 montos_pagados_ayudas_subsidios4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"7 Formato del Ejercicio del Destino y Gasto Federalizado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/7 formato_ejercicio_destino_gasto_federalizado4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"8 Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/8 norma_obligaciones_pagadas_garantizadas_fondos_federales4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"9 Norma para establecer la estructura de programas de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/9 norma_establecer_estructura_informacion_programas_recursos_federales_orden_ gobierno4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"10 Relación de Cuentas bancarias productivas especificas",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/10 relación_cuentas_bancarias_productivas_especificas4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"11 Norma para establecer el formato para la difusión de los resultados de las evaluaciones",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/11 norma_establecer_formato_difusión_resultados_evaluaciones4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/12 norma_fondo_aportaciones_educación_tecnologica4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"13 Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/13 norma_establecer_información_relativa_aportaciones_fed_materia_salud4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"14 Normas y modelo de estructura de información relativa alos Fondos de Ayuda Federal para la Seguridad Pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/14 norma_fondos_ayuda_fed_seg_publica4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"15 Norma para establecer la estructura de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/15 norma_formato_fondo_FORTAMUN4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"16 Lineamientos de información pública financiera para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/4. INFORMACION COMPLEMENTARIA/16 lineamientos_fondo_aportaciones_infraestructura_social4.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"REGISTRO PATRIMONIAL",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoria programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/3. INFORMACION PROGRAMATICA/gasto_categoria_programatica4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Bienes inmuebles",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/5. BIENES MUEBLES E INMUEBLES/bienes_inmuebles4.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Bienes muebles",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/5. BIENES MUEBLES E INMUEBLES/bienes_muebles4.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"CUENTA PÚBLICA 2018",
            "archivos_array":[
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"CUENTA PÚBLICA 2018",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Cuarto Trimestre 2018/Cuenta Publica 2018.zip"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"TERCER TRIMESTRE 2018",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/1.  INF_CONTABLE/ENDEUDAMIENTO NETO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analitíco de la deuda y otros pasivos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/1.  INF_CONTABLE/ESTADO ANALITÍCO DE LA DEUDA Y OTROS PASIVOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analitíco del activo",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/1.  INF_CONTABLE/ESTADO ANALÍTICO DEL ACTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/1.  INF_CONTABLE/ESTADO DE ACTIVIDADES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de cambios en la situación financiera",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/1.  INF_CONTABLE/ESTADO DE CAMBIOS EN LA SITUACIÓN FINANCIERA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo efectivo",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/1.  INF_CONTABLE/ESTADO DE FLUJO DE EFECTIVO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/1.  INF_CONTABLE/ESTADO DE SITUACIÓN FINANCIERA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/1.  INF_CONTABLE/ESTADO DE VARIACIÓN EN LA HACIENDA PÚBLICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de pasivos contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/1.  INF_CONTABLE/INFORME DE PASIVOS CONTINGENTES.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/1.  INF_CONTABLE/INTERESES DE LA DEUDA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas a los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/1.  INF_CONTABLE/Notas a los Estados Financieros .pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de ing. por rubro de ingresos y fuente de financiamiento",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/2. INF_PRESUPUESTARIA/ESTADO ANALÍTICO DE ING. POR RUBRO DE INGRESOS Y FUENTE DE FINANCIAMIENTO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del egreso por clasificación administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/2. INF_PRESUPUESTARIA/ESTADO ANALITICO DEL  EGRESO POR CLASIFICACIÓN ADMINISTRATIVA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del presupuesto de egresos por capítulo del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/2. INF_PRESUPUESTARIA/ESTADO ANALITICO DEL  PRESUPUESTO DE EGRESOS POR CAPÍTULO DEL GATO.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del egreso por clasificación económica",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/2. INF_PRESUPUESTARIA/ESTADO ANALITICO DEL EGRESO POR CLASIFICACIÓN ECONÓMICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del egreso por clasificación funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/2. INF_PRESUPUESTARIA/ESTADO ANALITICO DEL EGRESO POR CLASIFICACIÓN FUNCIONAL.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del egreso por FF capítulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/2. INF_PRESUPUESTARIA/ESTADO ANALITICO DEL EGRESO POR FF CAPÍTULO Y PARTIDA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del egreso por objeto del gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/2. INF_PRESUPUESTARIA/ESTADOANALITICO DEL EGRESO  POR OBJETO DEL GASTO.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoria programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/3. INF_PROGRAMATICA/Gasto por categoria programática.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Indicadores de resultados",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/3. INF_PROGRAMATICA/Indicadores de Resultados.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Programas y proyectos de inversión",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/3. INF_PROGRAMATICA/Programas y Proyectos de Inversión.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"1 Norma para presentar la información adicional a la iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/1 Norma para presentar la información adicional a la iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"2 norma para presentar la información adicional del Proyecto del Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/2 norma para presentar la información adicional del Proyecto del Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"3 Difusión a la Ciudadania de la Ley de Ingresos y del Presupuesto Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/3 Difusión a la Ciudadania de la Ley de Ingresos y del Presupuesto Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"4 Norma para establecer la estructura del Calendario de Ingresos Base mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/4 Norma para establecer la estructura del Calendario de Ingresos Base mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"5 Norma para establecer la estructura del Calendario del Presupuesto de Egresos base mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/5 Norma para establecer la estructura del Calendario del Presupuesto de Egresos base mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"6 Montos Pagados por Ayudas y Subsidios",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/6 Montos Pagados por Ayudas y Subsidios.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"7 Formato del Ejercicio del Destino y Gasto Federalizado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/7 Formato del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"8 Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/8 Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"9 Norma para establecer la estructura de programas de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/9 Norma para establecer la estructura de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"10 Relación de Cuentas bancarias productivas especificas",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/10 Relación de Cuentas bancarias productivas especificas.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"11 Norma para establecer el formato para la difusión de los resultados de las evaluaciones",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/11 Norma para establecer el formato para la difusión de los resultados de las evaluaciones.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"13 Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/13 Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"14 Normas y modelo de estructura de información relativa alos Fondos de Ayuda Federal para la Seguridad Pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/14 Normas y modelo de estructura de información relativa alos Fondos de Ayuda Federal para la Seguridad Pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"15 Norma para establecer la estructura de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Tercer Trimestre 2018/4. INFORMACIÓN COMPLEMENTARIA/15 Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"SEGUNDO TRIMESTRE 2018",
      "titulos_array":[
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Dictamen a los Estados Financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Dictamen a los Estados Financieros.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Endeudamiento Neto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Endeudamiento Neto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analitico de la Deuda y Otros Pasivos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Estado Analitico de la Deuda y Otros Pasivos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analitico del Activo",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Estado Analitico del Activo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de Actividades",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Estado de Actividades.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de Cambios en la Situación Financiera",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Estado de Cambios en la Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de Flujos de Efectivo",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Estado de Flujos de Efectivo.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de Situación Financiera",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Estado de Situación Financiera.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de Variación en la Hacienda Pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Estado de Variación en la Hacienda Pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Informe de Pasivos Contingentes",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Informe de Pasivos Contingentes.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Intereses de la Deuda",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Intereses de la Deuda.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas  a los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/1 INFORMACION CONTABLE/Notas  a los estados financieros.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado Analitico de Ingresos por Rubro y por Fuente de Financiamiento",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/2 INFORMACION PRESUPUESTARIA/Estado Analitico de Ingresos por Rubro y por Fuente de Financiamiento.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Calsificación Administrativa",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/2 INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Calsificación Administrativa.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Calsificación Funcional",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/2 INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Calsificación Funcional.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Capitulo del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/2 INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Capitulo del Gasto.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Clasificación Economica",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/2 INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Clasificación Economica.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por fuente de financiamiento, capitulo y partida",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/2 INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por fuente de financiamiento, capitulo y partida.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado del Ejercicio del Presupuesto de Egresos por Objeto del Gasto",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/2 INFORMACION PRESUPUESTARIA/Estado del Ejercicio del Presupuesto de Egresos por Objeto del Gasto.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"GASTO POR CATEGORIA PROGRAMATICA",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/3 INFORMACION PROGRAMATICA/GASTO POR CATEGORIA PROGRAMATICA.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"INDICADORES DE RESULTADOS",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/3 INFORMACION PROGRAMATICA/INDICADORES DE RESULTADOS.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"PROGRAMAS Y PROYECTOS DE INVERSIÓN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/3 INFORMACION PROGRAMATICA/PROGRAMAS Y PROYECTOS DE INVERSIÓN.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"1 Norma para presentar la información adicional a la iniciativa de la Ley de Ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/1 Norma para presentar la información adicional a la iniciativa de la Ley de Ingresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"2 norma para presentar la información adicional del Proyecto del Presupuesto de Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/2 norma para presentar la información adicional del Proyecto del Presupuesto de Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"3 Difusión a la Ciudadania de la Ley de Ingresos y del Presupuesto Egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/3 Difusión a la Ciudadania de la Ley de Ingresos y del Presupuesto Egresos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"4 Norma para establecer la estructura del Calendario de Ingresos Base mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/4 Norma para establecer la estructura del Calendario de Ingresos Base mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"4 Norma para establecer la estructura del Calendario del Presupuesto de Egresos base mensual",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/4 Norma para establecer la estructura del Calendario del Presupuesto de Egresos base mensual.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"7 Formato del Ejercicio del Destino y Gasto Federalizado",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/7 Formato del Ejercicio del Destino y Gasto Federalizado.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"8 Norma obligaciones pagadas o garantizadas con fondos federales",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/8 Norma obligaciones pagadas o garantizadas con fondos federales.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"9 Norma para establecer la estructura de informacion de programas de recursos federales por orden de gobierno",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/9 Norma para establecer la estructura de informacion de programas de recursos federales por orden de gobierno.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"10 Relación de Cuentas bancarias productivas especificas",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/10 Relación de Cuentas bancarias productivas especificas.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"11 Norma para establecer el formato para la difusión de los resultados de las evaluaciones",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/11 Norma para establecer el formato para la difusión de los resultados de las evaluaciones.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/12 Norma de Fondo de Aportaciones para la Educación Tecnologica y de adultos.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"13 Norma para establecer la información relativa a las aportaciones federales en materia de salud",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/13 Norma para establecer la información relativa a las aportaciones federales en materia de salud.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"14 Normas y modelo de estructura de información relativa alos Fondos de Ayuda Federal para la Seguridad Pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/14 Normas y modelo de estructura de información relativa alos Fondos de Ayuda Federal para la Seguridad Pública.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"15 Norma para establecer la estructura de información del formato del fondo FORTAMUN",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/15 Norma para establecer la estructura de información del formato del fondo FORTAMUN.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"16 Lineamientos de información pública financiera para el Fondo de Aportaciones para la Infraestructura Social",
                  "file_item_url":"../../contenido/transparencia/armonizacion/Segundo Trimestre 2018/4 INFORMACION COMPLEMENTARIA/16 Lineamientos de información pública financiera para el Fondo de Aportaciones para la Infraestructura Social.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":"PRIMER TRIMESTRE 2018",
      "titulos_array":[
         {
            "titulo_item_nombre":"ARMONIZACIÓN CONTABLE 2018",
            "archivos_array":[
               {
                  "extencion":"archivo-rar",
                  "file_item_nombre":"Primer Trimestre",
                  "file_item_url":"../../contenido/transparencia/armonizacion/1ER TRIMESTRE 2018.rar"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN CONTABLE",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de actividades",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/1. INFORMACION CONTABLE/estadoactividades1.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de situación financiera",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/1. INFORMACION CONTABLE/estadosituacionfinanciera1.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de variación en la hacienda pública",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/1. INFORMACION CONTABLE/estadovariacionhaciendapublica1.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado de flujo de efectivo",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/1. INFORMACION CONTABLE/estadoflujoefectivo1.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del activo",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/1. INFORMACION CONTABLE/estadoaaliticoactivo1.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de la deuda y otros pasivos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/1. INFORMACION CONTABLE/estadoanaliticodeudayotrospasivos1.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Notas a los estados financieros",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/1. INFORMACION CONTABLE/notas1.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PRESUPUESTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico de ingresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/2. INFORMACION PRESUPUESTARIA/estadoanaliticoingresos1.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estado analítico del ejercicio del presupuesto de egresos",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/2. INFORMACION PRESUPUESTARIA/estadoanaliticopresupuestoegresos.rar"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN PROGRAMATICA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Gasto por categoría programática",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/3. INFORMACIÓN PROGRAMÁTICA/gastocategoriaprogramatica1.pdf"
               }
            ]
         },
         {
            "titulo_item_nombre":"INFORMACIÓN COMPLEMENTARIA",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Normas",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/4. INFORMACIÓN COMPLEMENTARIA/normas1.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Estados de información económica",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/4. INFORMACIÓN COMPLEMENTARIA/cuentapublica2017.rar"
               }
            ]
         },
         {
            "titulo_item_nombre":"REGISTRO PATRIMONIAL",
            "archivos_array":[
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Bienes inmuebles",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/5. REGISTRO PATRIMONIAL/bienesmuebles-inmuebles.pdf"
               },
               {
                  "extencion":"archivo-pdf",
                  "file_item_nombre":"Bienes muebles",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2018/5. REGISTRO PATRIMONIAL/bienesmuebles1.pdf"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":" ",
      "titulos_array":[
         {
            "titulo_item_nombre":"ARMONIZACIÓN CONTABLE 2017",
            "archivos_array":[
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Primer Trimestre",
                  "file_item_url":"../../contenido/transparencia/armonizacion/1er-trimestre-2017.zip"
               },
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Segundo Trimestre",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2do-trimestre-2017.zip"
               },
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Tercer Trimestre",
                  "file_item_url":"../../contenido/transparencia/armonizacion/3er-trimestre-2017.zip"
               },
               {
                  "extencion":"archivo-rar",
                  "file_item_nombre":"Cuarto Trimestre",
                  "file_item_url":"../../contenido/transparencia/armonizacion/4o trimestre 2017.rar"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":" ",
      "titulos_array":[
         {
            "titulo_item_nombre":"ARMONIZACIÓN CONTABLE 2016",
            "archivos_array":[
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Primer Trimestre",
                  "file_item_url":"../../contenido/transparencia/armonizacion/1ER TRIMESTRE.zip"
               },
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Segundo Trimestre",
                  "file_item_url":"../../contenido/transparencia/armonizacion/2DO TRIMESTRE.zip"
               },
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Tercer Trimestre",
                  "file_item_url":"../../contenido/transparencia/armonizacion/3ER TRIMESTRE.zip"
               },
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Cuarto Trimestre",
                  "file_item_url":"../../contenido/transparencia/armonizacion/4TO TRIMESTRE.zip"
               }
            ]
         }
      ]
   },
   {
      "id_trimestre":" ",
      "titulos_array":[
         {
            "titulo_item_nombre":"ARMONIZACIÓN CONTABLE 2014 y 2015",
            "archivos_array":[
               {
                  "extencion":"archivo-zip",
                  "file_item_nombre":"Armonización Contable",
                  "file_item_url":"../../contenido/transparencia/armonizacion/INFORMACION PARA ARMONIZACION CONTABLE.zip"
               }
            ]
         }
      ]
   }
   
        
]